<template>
  <div class="cip-picker">
    <div class="autocomplete-wrapper">
      <PickerInput
        ref="suggestInput"
        :picker-id="pickerId"
        :aria-describedby="pickerId + '-cip-hint ' + pickerId + '-cip-details'"
        :aria-activedescendant="descendantAsign(highlightedIndex, pickerId, '-option-')"
        :aria-controls="showSuggestions ? pickerId + '-suggestions' : null"
        aria-label="CIP search"
        type="search"
      />

      <SuggestionsDropdown
        :picker-id="pickerId"
        :show-suggestions="showSuggestions"
        :suggestions="suggestions"
        :highlighted-index="highlightedIndex"
        :dropdown-style="dropdownStyle"
        dropdowntype="cip"
        @select-suggestion="selectSuggestion"
        @update-highlighted="highlightedIndex = $event"
      />

      <LoadingIndicator :loading="loading" />
    </div>

    <div
      v-show="inputShown"
      :id="pickerId + '-cip-hint'"
      class="hint"
    >
      <a
        href="https://nces.ed.gov/ipeds/cipcode/browse.aspx?y=55"
        title="Opens in a new window"
        data-tooltip="true"
        target="_blank"
      >
        Browse CIP codes
        <span
          class="icon-general_link_external"
          aria-hidden="true"
        ></span>
      </a>
    </div>

    <div
      v-if="shownLabel || shownDescription"
      :id="pickerId + '-cip-details'"
      class="vue-simple-picker__description"
    >
      <span
        v-if="shownLabel"
        class="vue-simple-picker__short-label"
      >
        {{ chosen?.shortLabel || chosen?.label }}
      </span>
      <span
        v-if="shownDescription"
        class="vue-simple-picker__code"
      >
        {{ chosen?.code }}
      </span>
      <span
        v-if="shownDescription"
        class="vue-simple-picker__label-description"
      >
        {{ chosen?.description }}
      </span>
    </div>

    <input
      :id="inputId"
      :value="fieldValue"
      :name="inputName"
      type="hidden"
    />

    <p v-if="debug">
      <strong>Hidden Input:</strong> {{ inputName }}={{ fieldValue }}<br />
      <strong>Initial Value:</strong> {{ inputValue }}
    </p>
  </div>
</template>

<script>
import BasePicker from './onet_naics_shared';
import LoadingIndicator from './LoadingIndicator.vue';
import PickerInput from './PickerInput.vue';
import SuggestionsDropdown from './SuggestionsDropdown.vue';
import './vue_picker.css';

export default {
  name: 'CipPicker',

  components: {
    LoadingIndicator,
    PickerInput,
    SuggestionsDropdown,
  },

  extends: BasePicker,

  methods: {
    apiUrl() {
      return '/lookup/classification_of_instructional_program_lookups.json';
    },

    async fetchSuggestions() {
      try {
        const results = await this.populateLookupData();

        this.suggestions = results.slice(0, 25); // Max 25
        this.showSuggestions = true;
        this.highlightedIndex = -1;
        this.takeLocation();
      } catch (_error) {
        this.suggestions = [];
        this.showSuggestions = false;
      }
    },
  },
};
</script>
